'use strict';
/////////////////////////////////////////////////
/////////////////////////////////////////////////
// BANKIST APP
// // Data
// const account1 = {
//   owner: 'Eslam Alawy',
//   movements: [200, 450, -400, 3000, -650, -130, 70, 1300],
//   interestRate: 1.2, // %
//   pin: 1111,
// };
// const account2 = {
//   owner: 'Jessica Davis',
//   movements: [5000, 3400, -150, -790, -3210, -1000, 8500, -30],
//   interestRate: 1.5,
//   pin: 2222,
// };
// const account3 = {
//   owner: 'Steven Thomas Williams',
//   movements: [200, -200, 340, -300, -20, 50, 400, -460],
//   interestRate: 0.7,
//   pin: 3333,
// };
// const account4 = {
//   owner: 'Sarah Smith',
//   movements: [430, 1000, 700, 50, 90],
//   interestRate: 1,
//   pin: 4444,
// };
// const accounts = [account1, account2, account3, account4];
// DIFFERENT DATA! Contains movement dates, currency and locale
const account1 = {
    owner: 'Eslam Alawy',
    movements: [
        200,
        455.23,
        -306.5,
        25000,
        -642.21,
        -133.9,
        79.97,
        1300
    ],
    interestRate: 1.2,
    pin: 1111,
    movementsDates: [
        '2024-11-18T21:31:17.178Z',
        '2024-11-23T07:42:02.383Z',
        '2024-11-28T09:15:04.904Z',
        '2024-12-01T10:17:24.185Z',
        '2024-12-08T14:11:59.604Z',
        '2024-11-27T17:01:17.194Z',
        '2024-12-11T23:36:17.929Z',
        '2024-12-12T10:51:36.790Z'
    ],
    currency: 'EUR',
    locale: 'pt-PT'
};
const account2 = {
    owner: 'Jessica Davis',
    movements: [
        5000,
        3400,
        -150,
        -790,
        -3210,
        -1000,
        8500,
        -30
    ],
    interestRate: 1.5,
    pin: 2222,
    movementsDates: [
        '2024-11-01T13:15:33.035Z',
        '2024-11-30T09:48:16.867Z',
        '2024-11-25T06:04:23.907Z',
        '2024-11-25T14:18:46.235Z',
        '2024-12-05T16:33:06.386Z',
        '2024-11-10T14:43:26.374Z',
        '2024-11-25T18:49:59.371Z',
        '2024-11-26T12:01:20.894Z'
    ],
    currency: 'USD',
    locale: 'en-US'
};
const accounts = [
    account1,
    account2
];
// Elements
const labelWelcome = document.querySelector('.welcome');
const labelDate = document.querySelector('.date');
const labelBalance = document.querySelector('.balance__value');
const labelSumIn = document.querySelector('.summary__value--in');
const labelSumOut = document.querySelector('.summary__value--out');
const labelSumInterest = document.querySelector('.summary__value--interest');
const labelTimer = document.querySelector('.timer');
const containerApp = document.querySelector('.app');
const containerMovements = document.querySelector('.movements');
const btnLogin = document.querySelector('.login__btn');
const btnTransfer = document.querySelector('.form__btn--transfer');
const btnLoan = document.querySelector('.form__btn--loan');
const btnClose = document.querySelector('.form__btn--close');
const btnSort = document.querySelector('.btn--sort');
const inputLoginUsername = document.querySelector('.login__input--user');
const inputLoginPin = document.querySelector('.login__input--pin');
const inputTransferTo = document.querySelector('.form__input--to');
const inputTransferAmount = document.querySelector('.form__input--amount');
const inputLoanAmount = document.querySelector('.form__input--loan-amount');
const inputCloseUsername = document.querySelector('.form__input--user');
const inputClosePin = document.querySelector('.form__input--pin');
const formatCur = function(value, locale, currency) {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
    }).format(value);
};
const formatMovmentDate = function(date, locale) {
    const calcDaysPassed = (date1, date2)=>Math.round(Math.abs(date2 - date1) / 86400000);
    const daysPassed = calcDaysPassed(new Date(), date);
    if (daysPassed === 0) return 'Today';
    else if (daysPassed === 1) return 'Yesterday';
    else if (daysPassed <= 7) return `${daysPassed} days ago`;
    return new Intl.DateTimeFormat(locale).format(date);
};
const displayMovements = function(acc, sort = false) {
    containerMovements.innerHTML = '';
    const movs = sort ? acc.movements.slice().sort((a, b)=>a - b) : acc.movements;
    movs.forEach((mov, i)=>{
        const type = mov > 0 ? 'deposit' : 'withdrawal';
        const date = new Date(acc.movementsDates[i]);
        const displayDate = formatMovmentDate(date, acc.locale);
        const formatedMov = formatCur(mov, acc.locale, acc.currency);
        const html = `
    <div class="movements__row">
          <div class="movements__type movements__type--${type}">${i + 1} ${type}</div>
    <div class="movements__date">${displayDate}</div>
          <!-- <div class="movements__value">${mov.toFixed(2)}\u{20AC}</div> -->
          <div class="movements__value">${formatedMov}</div>
    </div>
    `;
        containerMovements.insertAdjacentHTML('afterbegin', html);
    });
};
const calcDisplayBalance = (acc)=>{
    acc.balance = acc.movements.reduce((acc, mov)=>acc + mov, 0);
    // labelBalance.textContent = `${acc.balance.toFixed(2)}€`;
    labelBalance.textContent = formatCur(acc.balance, acc.locale, acc.currency);
};
const calcDisplaySummary = (acc)=>{
    const incomes = acc.movements.filter((mov)=>mov > 0).reduce((acc, mov)=>acc + mov, 0);
    // labelSumIn.textContent = `${incomes.toFixed(2)}€`;
    labelSumIn.textContent = formatCur(incomes, acc.locale, acc.currency);
    const out = Math.abs(acc.movements.filter((mov)=>mov < 0).reduce((acc, mov)=>acc + mov, 0));
    // labelSumOut.textContent = `${out.toFixed(2)}€`;
    labelSumOut.textContent = formatCur(out, acc.locale, acc.currency);
    const interest = acc.movements.filter((mov)=>mov > 0).map((deposit)=>deposit * acc.interestRate / 100).filter((int, i, arr)=>int >= 1).reduce((acc, int)=>acc + int, 0);
    // labelSumInterest.textContent = `${interest.toFixed(2)}€`;
    labelSumInterest.textContent = formatCur(interest, acc.locale, acc.currency);
};
const createUsernames = (accs)=>accs.forEach((acc)=>{
        acc.username = acc.owner.toLocaleLowerCase().split(' ').map((name)=>name[0]).join('');
    });
createUsernames(accounts);
// console.log(accounts);
const startLogOutTimer = function() {
    const tick = ()=>{
        const min = String(Math.trunc(time / 60)).padStart(2, 0);
        const sec = String(time % 60).padStart(2, 0);
        // in each call, print the remaining time to UI
        labelTimer.textContent = `${min}:${sec}`;
        // when 0 second, stop timer and logout the user
        if (time === 0) {
            clearInterval(timer);
            containerApp.style.opacity = 0;
            labelWelcome.textContent = 'Log in to get started';
        }
        // Decrese 1s
        time--;
    };
    // set time to 5 mins
    let time = 120;
    // call the timer every second
    tick(); // to start immediatly
    const timer = setInterval(tick, 1000);
    return timer;
};
const resetTimer = (_)=>{
    clearInterval(timer);
    timer = startLogOutTimer();
};
let currentAccount, timer;
// display date
// const now = new Date();
// const day = `${now.getDate()}`.padStart(2, 0);
// const month = `${now.getMonth() + 1}`.padStart(2, 0);
// const year = now.getFullYear();
// const hour = `${now.getHours()}`.padStart(2, 0);
// const min = `${now.getMinutes()}`.padStart(2, 0);
// labelDate.textContent = `${day}/${month}/${year}, ${hour}:${min}`;
btnLogin.addEventListener('click', function(e) {
    e.preventDefault();
    currentAccount = accounts.find((acc)=>acc.username === inputLoginUsername.value);
    if (currentAccount?.pin === +inputLoginPin.value) {
        // Display UI and message
        labelWelcome.textContent = `Welcome back ${currentAccount.owner.split(' ')[0]}`;
        containerApp.style.opacity = 100;
        //create current date and time
        //experimenting API
        //http://www.lingoes.net/en/translator/langcode.htm
        const now = new Date();
        const options = {
            hour: 'numeric',
            minute: 'numeric',
            day: 'numeric',
            month: 'numeric',
            // month: 'long',
            // month: '2-digit',
            year: 'numeric'
        };
        // const locale = navigator.language;
        // console.log(locale);
        // labelDate.textContent = new Intl.DateTimeFormat('en-US', options).format(now);
        // labelDate.textContent = new Intl.DateTimeFormat(locale, options).format(
        //   now
        // );
        labelDate.textContent = new Intl.DateTimeFormat(currentAccount.locale, options).format(now);
        //clear fields
        inputLoginPin.value = inputLoginUsername.value = '';
        inputLoginPin.blur(); //lose it's focus cursor
        if (timer) clearInterval(timer);
        timer = startLogOutTimer();
        updateUI(currentAccount);
    }
});
const updateUI = (acc)=>{
    // Display movements
    displayMovements(acc);
    // Disce
    calcDisplayBalance(acc);
    // Display summary
    calcDisplaySummary(acc);
};
btnTransfer.addEventListener('click', function(e) {
    e.preventDefault();
    const amount = +inputTransferAmount.value;
    const receiverAcc = accounts.find((acc)=>acc.username === inputTransferTo.value);
    inputTransferAmount.value = inputTransferTo.value = '';
    if (amount > 0 && receiverAcc && amount <= currentAccount.balance && receiverAcc?.username !== currentAccount.username) {
        // Doing the transfer
        currentAccount.movements.push(-amount);
        receiverAcc.movements.push(amount);
        // Add transfer date
        currentAccount.movementsDates.push(new Date().toISOString());
        receiverAcc.movementsDates.push(new Date().toISOString());
        // Update the ui
        updateUI(currentAccount);
        // Reset timer
        resetTimer();
    }
});
btnLoan.addEventListener('click', function(e) {
    e.preventDefault();
    const amount = Math.floor(inputLoanAmount.value);
    if (amount > 0 && currentAccount.movements.some((mov)=>mov >= 0.1 * amount)) setTimeout(function() {
        //add the movement
        currentAccount.movements.push(amount);
        //add loan date
        currentAccount.movementsDates.push(new Date().toISOString());
        //update UI
        updateUI(currentAccount);
        // Reset timer
        resetTimer();
    }, 3000);
    inputLoanAmount.value = '';
});
btnClose.addEventListener('click', function(e) {
    e.preventDefault();
    if (inputCloseUsername.value === currentAccount.username && +inputClosePin.value === currentAccount.pin) {
        const index = accounts.findIndex((acc)=>acc.username === currentAccount.username);
        //delete the account
        accounts.splice(index, 1);
        //Hide UI
        containerApp.style.opacity = 0;
    }
    inputCloseUsername.value = inputClosePin.value = '';
});
// const overalBalance = accounts
//   .flatMap(acc => acc.movements)
//   .reduce((acc, mov) => acc + mov, 0);
// console.log(overalBalance);
let isSorted = false;
btnSort.addEventListener('click', function(e) {
    e.preventDefault();
    displayMovements(currentAccount, !isSorted);
    isSorted = !isSorted;
});
labelBalance.addEventListener('click', function() {
    [
        ...document.querySelectorAll('.movements__row')
    ].forEach((row, i)=>{
        //0,2,4,6
        if (i % 2 === 0) row.style.backgroundColor = 'orangered';
    // 0,3,6,9
    // if (i % 3 === 0) row.style.backgroundColor = 'blue';
    });
}); // console.log(typeof(29n));

//# sourceMappingURL=index.7de29baa.js.map
